T.Length = Class(
	/**
	 * @lends {T.Length#}
	 */
	{
		__construct(par) {
			this.par = par || {};
			this._n = ++T.Length._n;

			this.node = mkE({
				tag: 'div',
				className: 'form-group form-group-length'
			});

			if (par.label) {
				this._label = mkE({
					tag: 'label',
					attr: {
						for: 'form-length-' + this._n
					},
					text: par.label
				}).append(this.node);
			}

			this._text = mkE({
				tag: 'div',
				className: 'form-control',
				els: [
					this._textNode = mkE({
						tag: 'span',
						text: typeof par.value !== 'undefined' ? par.value + 'h' : '0h'
					})
				]
			}).append(this.node);

			mkE({
				tag: 'a',
				className: 'decrease',
				onclick: this._decrease
			}).append(this._text);

			mkE({
				tag: 'a',
				className: 'increase',
				onclick: this._increase
			}).append(this._text);

			this._input = mkE({
				tag: 'input',
				type: 'hidden',
				name: par.name,
				id: 'form-length-' + this._n,
				value: typeof par.value !== 'undefined' ? par.value : ''
			}).append(this.node);

			if (par.help) {
				mkE({
					tag: 'small',
					className: 'form-text text-muted',
					text: par.help
				}).append(this.node);
			}

			this._errorNode = mkE({
				tag: 'div',
				className: 'invalid-feedback'
			}).append(this.node);

			if (par.disabled) {
				this.disabled(par.disabled);
			}

			if (par.readOnly) {
				this.readOnly(par.readOnly);
			}
		},

		value(v) {
			if (typeof v === "undefined") {
				return Number(this._input.value);
			}
			this._input.value = v;
			setNodeText(this._textNode, v + 'h');
			return Number(this._input.value);
		},

		error(error) {
			clearNode(this._errorNode);
			if (!error) {
				removeClassName(this._text, 'is-invalid');
				return;
			}
			addClassName(this._text, 'is-invalid');
			mkE.appendTypeElement(this._errorNode, error);
		},

		_increase() {
			let current = this.value();
			if (current === 99) {
				return;
			}
			this.value(current + 1);
		},

		_decrease() {
			let current = this.value();
			if (current === 0) {
				return;
			}
			this.value(current - 1);
		}
	},
	mkE.Base
)